import { Fingerprint } from 'lucide-react'
import { useState } from 'react'

import { Button, Modal } from '@/components/ui'
import { useAuthStore } from '@/stores/authStore'

import { CadastrarAparelhoModal } from './CadastrarAparelhoModal'

/**
 * Convite para cadastrar a biometria logo após o login. Reaparece a cada login enquanto a
 * sessão não estiver vinculada. Renderizar só quando `useOfertaBiometriaPendente()` for `true`.
 */
export function OfertaBiometriaPrompt() {
  const dispensar = useAuthStore((state) => state.setOfertarBiometria)
  const [cadastrando, setCadastrando] = useState(false)

  // O cadastro bem-sucedido desliga `ofertarBiometria` (ver `useCadastrarAparelho`).
  if (cadastrando) return <CadastrarAparelhoModal onClose={() => setCadastrando(false)} />

  return (
    <Modal
      open
      onClose={() => dispensar(false)}
      title="Proteja seu acesso"
      footer={
        <>
          <Button variant="ghost" onClick={() => dispensar(false)}>
            Agora não
          </Button>
          <Button onClick={() => setCadastrando(true)}>Cadastrar biometria</Button>
        </>
      }
    >
      <div className="flex items-start gap-3">
        <span className="grid size-10 shrink-0 place-items-center rounded-lg bg-brand/10 text-brand">
          <Fingerprint className="size-5" />
        </span>
        <p className="text-sm text-fg-muted">
          Cadastre a digital, o rosto ou o bloqueio de tela deste aparelho. Quando o sistema pedir
          confirmação, você desbloqueia com a biometria em vez de digitar a senha.
        </p>
      </div>
    </Modal>
  )
}
